import React, { useState } from 'react';
import axios from 'axios';
import Loader from '../components/Loader';

const GeneralQueryPage = () => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState('');
  const [query, setQuery] = useState('');

  const handleQuery = async (e) => {
    e.preventDefault();
    if (query.trim() === '') {
      setResponse('Please enter a question.');
      return;
    }
    setLoading(true);
    setResponse('');
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/ai/general-query`, { query });
      setResponse(res.data.response);
    } catch (error) {
      console.error('Error querying AI:', error);
      setResponse('Error querying AI.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-3xl mx-auto bg-gray-100 rounded-md shadow-lg">
      <h2 className="text-2xl font-bold mb-4">General Query</h2>
      <form onSubmit={handleQuery} className="mb-4">
        <label className="block font-semibold mb-2">Ask a Question</label>
        <div className="flex">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="border p-2 w-full rounded-l-md"
            placeholder="Enter your question here"
            required
          />
          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded-r-md hover:bg-blue-600"
          >
            Ask
          </button>
        </div>
      </form>
      {loading && <Loader />}
      <div className="border p-4 bg-white shadow-md rounded-md">
        {response ? <div dangerouslySetInnerHTML={{ __html: response }} /> : 'Enter a question to get the response.'}
      </div>
    </div>
  );
};

export default GeneralQueryPage;
